/*
Props that turn a non-button element (a card, a KPI tile, a list row) into a
keyboard-reachable control. These elements hold layout and an InfoTooltip, so
they can't be a real <button>.

Enter/Space only fire when the element itself has focus, so a keypress on the
nested tooltip trigger doesn't also apply the filter.
*/
export const clickableProps = function (onActivate, active) {
  if (!onActivate) return {};
  return {
    role: "button",
    tabIndex: 0,
    "aria-pressed": !!active,
    onClick: onActivate,
    onKeyDown: function (e) {
      if (e.target !== e.currentTarget) return;
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onActivate();
      }
    },
  };
};

export default clickableProps;
